var map = {
	"./section-img-01.jpg": 459,
	"./section-img-02.jpg": 476,
	"./section-img-03.jpg": 529,
	"./section-img-04.jpg": 634,
	"./section-img-05.jpg": 471,
	"./section-img-06.jpg": 16,
	"./section-img-07.jpg": 885
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 445;